import {FormSectionElements} from "../entities/formTemplateDataType";
import Utils from "./Utils";

const SubmitButtonTypes = ['Button', 'PublicSecureButton', 'RecaptchaButton', 'RepeatButton'];

export const getSubmitResponseData = (field: FormSectionElements, response: any) => {
    let responseData = response.data;
    if (response.data
        && (SubmitButtonTypes.includes(field.Type)
            || SubmitButtonTypes.includes(field.Datatype))
        && field.SubmitButton?.responseDataName) {
        responseData = response.data[field.SubmitButton.responseDataName];
    }
    return responseData;
}

export const getRedirectPageOnReponse = (field: FormSectionElements, response: any) => {
    if (!SubmitButtonTypes.includes(field.Datatype)) return null;

    const responseData = getSubmitResponseData(field, response);
    field.apiResponse = responseData;

    let statusCodeinString: string;
    if (typeof responseData === 'number') {
        statusCodeinString = responseData.toString();
    } else if (typeof responseData === 'string') {
        statusCodeinString = responseData.trim();
    } else if (typeof response.status === 'number') {
        statusCodeinString = response.status.toString();
    }

    if (field.parent.parent.parent.CategoryId?.toLowerCase() === 'odr'
        || field.parent.parent.parent.CategoryId?.toLowerCase() === 'chc') {
        if (responseData && !Utils.isNullOrEmpty(responseData['statusCode'])) {
            statusCodeinString = responseData['statusCode'].toString();
        }
    }

    const page = field.SubmitButton?.apiSuccessRedirectPage?.filter(page => page.statusCode == statusCodeinString);
    
    if (page?.length) {
        return page[0].redirectPage;
    }
    return null;
}

